<template>
    <div class="form-switch-block mb-8">
        <div class="mb-8 w-full border-t border-zinc-300" />
        <div class="flex flex-row space-x-6">
            <content-subheading class="flex-1" :heading="heading" marginBottom="mb-5"></content-subheading>
            <div class="subheading font-italic pr-2" v-if="field && toggle">
                <button
                    type="button"
                    @click="toggle(field)"
                    class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-amber-600 focus:ring-offset-2"
                    :class="!!value ? 'bg-amber-600' : 'bg-gray-400'"
                    role="switch"
                    aria-checked="false"
                >
                    <span class="sr-only">Use setting</span>
                    <span
                        aria-hidden="true"
                        class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                        :class="!!value ? 'translate-x-5' : 'translate-x-0'"
                    ></span>
                </button>
            </div>
            <div class="pr-2 italic" v-else>
                {{ noSwitchText }}
            </div>
        </div>
        <content-text v-if="content" :html="content" :textMaxWidth="false"></content-text>
    </div>
</template>

<script>
export default {
    name: 'FormSwitchBlock',
    props: ['heading', 'content', 'field', 'value', 'toggle', 'noSwitchText'],
};
</script>
